import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3 11h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2","key":"svg-0"}],["path",{"d":"M19 7h-4l-.001 -4.001z","key":"svg-1"}]]

const IconFileMinusFilled = createReactComponent('filled', 'file-minus-filled', 'FileMinusFilled', __iconNode);

export default IconFileMinusFilled;